/**
 * LoadFuelConfirmModal — final-confirm before the Stripe charge fires.
 *
 * Rebuilt off the legacy the legacy component stack as part of the the legacy component retirement.
 * Uses the shared `Modal` primitive + native `<button>`. Visual treatment
 * lives in `LoadFuelConfirmModal.scss` next to this file.
 */

import React from "react";
import {FiAlertTriangle, FiX} from "react-icons/fi";
import {Modal} from "@/widgets/Modal";
import "./LoadFuelConfirmModal.scss";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    onConfirm: () => void;
}

export default function LoadFuelConfirmModal(props: Props) {
    function handleConfirm() {
        props.toggle();
        props.onConfirm();
    }

    return (
        <Modal
            isOpen={props.isOpen}
            toggle={props.toggle}
            contentClassName="lfp2-confirm-modal"
            size="xs2"
            ariaLabel="Confirm Load Fuel"
        >
            <button
                type="button"
                className="lfp2-confirm-modal__close"
                onClick={props.toggle}
                aria-label="Close"
            >
                <FiX aria-hidden="true" />
            </button>

            <div className="lfp2-confirm-modal__body">
                <span className="lfp2-confirm-modal__eyebrow">
                    <FiAlertTriangle aria-hidden="true" />
                    Confirm
                </span>

                <h2 className="lfp2-confirm-modal__title">
                    Load {import.meta.env.VITE_TOKEN_NAME} Now?
                </h2>

                <p className="lfp2-confirm-modal__copy">
                    The purchase of {import.meta.env.VITE_TOKEN_NAME} is final.
                    {" "}{import.meta.env.VITE_TOKEN_NAME} is non-refundable and non-returnable.
                </p>
            </div>

            <div className="lfp2-confirm-modal__cta-row">
                <button
                    type="button"
                    className="lfp2-confirm-modal__cancel"
                    onClick={props.toggle}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="lfp2-confirm-modal__confirm"
                    onClick={handleConfirm}
                >
                    Confirm Purchase
                </button>
            </div>
        </Modal>
    );
}
